function videoTextSlider() {
  let videos = document.querySelectorAll(
    '.hero__text-wrap-video-block .hero__text-content',
  );

  if (!videos.length) return;

  videos.forEach((video) => {
    new Flickity(video, {
      contains: true,
      wrapAround: true,
      cellAlign: 'left',
      pageDots: true,
      prevNextButtons: false,
      autoPlay: 3000
    });
  });
}

function animateCounter(element) {
  const counterElement = element.querySelector('.counter');
  const rawText = counterElement.textContent.trim();

  let suffix = '';
  if (rawText.includes('%')) {
    suffix = '%';
  } else if (rawText.includes('+')) {
    suffix = '+';
  }

  const finalValue = parseInt(rawText.replace(/[^0-9]/g, ''), 10);

  let currentValue = 0;
  const duration = 1500;
  const steps = 50;
  const increment = finalValue / steps;
  const stepDuration = duration / steps;

  const interval = setInterval(() => {
    currentValue += increment;

    if (currentValue >= finalValue) {
      counterElement.textContent = finalValue + suffix;
      clearInterval(interval);
    } else {
      counterElement.textContent = Math.floor(currentValue) + suffix;
    }
  }, stepDuration);
}


document.addEventListener('DOMContentLoaded', function () {
  videoTextSlider();

  const counters = document.querySelectorAll('.number-counter');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => observer.observe(counter));
});


